import React, { createRef } from "react"
import {
    Box,
    Button,
    Divider,
    Menu,
    Stack,
    TextField,
    Typography,
} from "@mui/material"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import SearchIcon from "@mui/icons-material/Search"

import {
    Trans,
} from "@lingui/macro"
import {
    Controller,
    UseFormReturn,
} from "react-hook-form"

import { theme } from "index"
import Icon from "@mdi/react";
import {mdiCached} from "@mdi/js";

interface AdvancedSearchbarProps extends UseFormReturn, Readonly<{ children?: React.ReactNode }>
{
    onSearch: (data: Record<string, any>) => void
    searchFieldName: string
    searchFieldPlaceholder: string
    disableMenu?: boolean
    clearFormButton?: boolean
}
interface AdvancedSearchbarState
{
    openFilters: boolean
}
export class AdvancedSearchbar extends React.Component<AdvancedSearchbarProps, AdvancedSearchbarState>
{
    static defaultProps = {
        clearFormButton: false,
    };

    private searchFieldRef: React.RefObject<HTMLButtonElement> = createRef()

    constructor(props: AdvancedSearchbarProps)
    {
        super(props)

        this.state = {
            openFilters: false,
        }
    }

    private toggleAdvancedSearchBox = (): void => {
        this.setState(() => ({ openFilters: !this.state.openFilters, }))
    }

    private handleKeyPress = (event: any) => {
        if(event.key === "Enter") {
            this.handleSearch()
        }
    }

    private handleSearch = () => {
        this.setState(() => ({ openFilters: false, }))
        this.props.onSearch(this.props.getValues())
    }

    private handleClear = () => {
        this.setState(() => ({ openFilters: false, }), () => {
            const formFields = Object.keys(this.props.getValues());
            const clearedValues = formFields.reduce((acc: any, field: string) => {
                acc[field] = '';
                return acc;
            }, {});
            this.props.reset(clearedValues);
            this.props.onSearch(this.props.getValues())
        })
    }

    render()
    {
        return (
            <Box sx={{
                mt: 5,
                mx: "auto",
                width: "45%",
                borderRadius: 30,
                backgroundColor: theme.palette.background.default,
                px: 2,
            }}
                ref={this.searchFieldRef}
            >
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Controller
                        name={this.props.searchFieldName}
                        control={this.props.control}
                        defaultValue=""
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                {...field}
                                required={false}
                                size="medium"
                                placeholder={this.props.searchFieldPlaceholder}
                                sx={{
                                    p: .5,
                                    "& .MuiOutlinedInput-root": {
                                        fontSize: ".8em",
                                        "& fieldset": {
                                            border: 0,
                                        },
                                        "&:hover fieldset": {
                                            border: 0,
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: 0,
                                        },
                                    },
                                }}
                                onKeyDown={this.handleKeyPress}
                            />
                        )}
                    />
                    {!this.state.openFilters && !this.props.disableMenu &&
                        <KeyboardArrowDownIcon
                            onClick={this.toggleAdvancedSearchBox}
                            role="button"
                            sx={{ cursor: "pointer", fontSize: 50 }}
                        />}
                    {this.state.openFilters && !this.props.disableMenu &&
                        <KeyboardArrowUpIcon
                            onClick={this.toggleAdvancedSearchBox}
                            role="button"
                            sx={{ cursor: "pointer", fontSize: 50 }}
                        />}
                    <Divider orientation="vertical" flexItem sx={{ borderColor: "text.primary" }} />
                    <SearchIcon onClick={this.handleSearch}
                        role="button"
                        sx={{ cursor: "pointer", fontSize: 30 }}
                    />
                </Stack>

                <Menu
                    open={this.state.openFilters}
                    onClose={this.toggleAdvancedSearchBox}
                    anchorEl={this.searchFieldRef.current}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    MenuListProps={{sx: {p: 0}}}
                    slotProps={{
                        paper: { sx: {width: "50%"} }
                    }}
                    sx={{ mt: 1,  }}
                >
                    <Box sx={{ backgroundColor: "background.default", p: 2, width: "100%" }}>
                        {this.props.children}

                        <Box textAlign="center" sx={{ mt: 2 }}>
                            <Button
                                onClick={this.handleSearch}
                                variant="contained"
                                type="button"
                                disableElevation
                                sx={{
                                    textTransform: "none",
                                    backgroundColor: "secondary.main",
                                    paddingX: 3,
                                    height: 28,
                                    color: "background.default",
                                }}>
                                <Typography>
                                    <Trans id="search" comment="search button">
                                        Cerca
                                    </Trans>
                                </Typography>
                            </Button>
                            {
                                this.props.clearFormButton &&
                                <Button
                                    variant="contained"
                                    type="button"
                                    disableElevation
                                    color="neutral"
                                    sx={{
                                        textTransform: "none",
                                        height: 28,
                                        paddingX: 3,
                                        ml: 2
                                    }}
                                    onClick={this.handleClear}
                                    endIcon={<Icon path={mdiCached} size={1} />}
                                >
                                    <Typography>
                                        <Trans id={"clear-form"}>
                                            Pulisci
                                        </Trans>
                                    </Typography>
                                </Button>
                            }
                        </Box>
                    </Box>
                </Menu>
            </Box>
        )
    }
}
